// utils.js

import { jwtDecode } from 'jwt-decode';

import { getJsonFromStorage } from "@/util/storageUtils"; // Importer la fonction pour récupérer les données du stockage

export function isTokenExpiredLocally() {
  const token = localStorage.getItem('token');
  if (!token) return true;

  try {
    const decoded = jwtDecode(token);
    return decoded.exp * 1000 < Date.now(); // expiré
  } catch (e) {
    return true;
  }
}

// utils.js

export const isUserLoggedIn = () => {
  const token = localStorage.getItem('token');
  if (!token) {
    return false;
  }

  const decodedToken = jwtDecode(token);
  const currentTime = Date.now() / 1000;

  return decodedToken.exp > currentTime;
};

export const getUserData = () => {
  // Logique pour récupérer les données de l'utilisateur depuis le local storage ou ailleurs
  return getJsonFromStorage('userData');
};

// Autres fonctions utilitaires

const getHomeRouteForLoggedInUser = () => {
  // Replace with your logic to determine the home route for logged-in users
  return { name: 'home' };
};

export {  getHomeRouteForLoggedInUser };